import { Component, OnInit } from '@angular/core';
import { translate } from "@ngneat/transloco";

@Component({
  selector: 'preview-form',
  templateUrl: './preview-form.component.html',
  styleUrls: ['./preview-form.component.scss']
})
export class PreviewFormComponent implements OnInit {

  previewSteps: any[];
  currentStep: number;
  statusOptions: any[];
  statusOption: 'online' | 'offline';

  constructor() {}

  ngOnInit() {
    this.previewSteps = [
      {index: 0, icon: 'pi pi-sitemap', label: translate('preview.firstStep.name'), description: translate('preview.firstStep.description')},
      {index: 2, icon: 'pi pi-cog', label: translate('preview.secondStep.name'), description: translate('preview.secondStep.description')},
      {index: 3, icon: 'pi pi-tablet', label: translate('preview.thirdStep.name'), description: translate('preview.thirdStep.description')},
      {index: 4, icon: 'pi pi-check', label: translate('preview.confirmationStep.name')}
    ];
    this.currentStep = 2;
    this.statusOptions = [
      {label: 'Offline', value: 'offline'},
      {label: 'Online', value: 'online'}
    ];
    this.statusOption = 'offline';
  }

}
